import {ErrorHandler, Injectable} from '@angular/core';
import {ConfigService, SentryService} from '@q9elements/ui-kit/common';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  constructor(private sentryService: SentryService) {}

  handleError(err: any): void {
    if (ConfigService.environment.production) {
      this.sentryService.captureException(err);
    }
    console.error(err);
  }
}
